<template>
    <el-dialog
        :visible.sync="isDialogExportCustomer"
        width="45%"
        destroy-on-close
        center
        class="export"
        :close-on-click-modal="false"
        :show-close="false"
        :before-close="onCloseDialog"
    >
        <div class="title">
            <p>File Export</p>
        </div>
        <el-row>
            <el-col :span="9" class="type-box">
                <span>Type:</span>
            </el-col>
            <el-col :span="15">
                <el-radio-group v-model="typeExport">
                    <el-radio
                        v-for="item in exportList"
                        :key="`export-${item.label}`"
                        :label="item.label"
                        class="radio-box"
                    >
                        {{ item.text}}
                    </el-radio>
                </el-radio-group>
            </el-col>
            <el-col v-if="isNotSelectedCustomer" :span="24" class="err-message text-center">
                <span>กรุณากลับไปเลือกรายการที่ต้องการ Export</span>
            </el-col>
        </el-row>
        <div class="footer">
            <el-button
                class="btn-cancel"
                plain
                @click="onCloseDialog">
                Cancel
            </el-button>
            <el-button
                class="btn-export"
                type="primary"
                :disabled="isNotSelectedCustomer"
                @click="onExport">
                Export file
            </el-button>
        </div>
    </el-dialog>
</template>

<script>
import mixinExcel from '@/mixins/exportExcel.js'
import fgApi from '@/services/fillgoods'
import { ACCOUNT_STATUS, packageCode, SUBSCRIPTION_TYPE } from '@/constant/subscription.js'

export default {
    name: 'DialogExportCustomer',
    mixins: [mixinExcel],
    props: {
        isDialogExportCustomer: {
            type: Boolean,
            default: false
        },
        customerSelected: {
            type: Array,
            default: () => []
        },
        customerType: {
            type: String,
            default: 'leadPool'
        },
        customerFilter: {
            type: Object,
            default: () => {}
        },
        searchTextForFilter: {
            type: String,
            default: ''
        }
    },
    data () {
        return {
            typeExport: 'A',
            exportList: [
                {
                    label: 'A',
                    text: 'Export All'
                },
                {
                    label: 'S',
                    text: 'Export by Selection'
                },
                {
                    label: 'F',
                    text: 'Export by Search / Filter'
                }
            ]
        }
    },
    computed: {
        isNotSelectedCustomer () {
            return this.typeExport === 'S' && this.customerSelected.length < 1
        },
        exportParams () {
            switch (this.customerType) {
            case 'leadPool':
                return { is_created_order: false }
            case 'leadPoolCreatedOrder':
                return { is_created_order: true }
            default:
                return {}
            }
        }
    },
    methods: {
        onCloseDialog () {
            this.typeExport = 'A'
            this.$emit('onCloseDialog', false)
        },
        exportAIP (params) {
            switch (this.customerType) {
            case 'customer':
                return fgApi.subscription.customerExport(params)
            case 'approvedCustomer':
                return fgApi.subscription.approvedCustomerExport(params)
            case 'confirmCustomer':
                return fgApi.subscription.confirmCustomerExport(params)
            case 'leadPool':
            case 'leadPoolCreatedOrder':
                return fgApi.subscription.leadpoolCustomerExport(params)
            default:
                return fgApi.subscription.customerExport(params)
            }
        },
        async onExport () {
            this.$loading()
            if (this.isNotSelectedCustomer) {
                this.$loading().close()
                return
            }
            let params = {
                export_type: this.typeExport,
                ...this.exportParams
            }
            if (this.typeExport === 'S') {
                if (this.customerSelected.length > 0) {
                    const customerSelectedId = this.customerSelected.map(e => {
                        return e.userId
                    })
                    params.selection = customerSelectedId
                }
            } else if (this.typeExport === 'F') {
                params.search = this.searchTextForFilter
                params.package_code = this.customerFilter.package_code ? this.customerFilter.package_code : ''
                params.subscription_type = this.customerFilter.subscription_type ? this.customerFilter.subscription_type : ''
                params.account_status = this.customerFilter.account_status
                params.expire_within = this.customerFilter.expire_within ? 7 : null
            }
            let excelHeader = [[
                'Customer ID',
                'Name',
                'Surname',
                'Email',
                'Phone no.',
                'Field Sales',
                'Secondary Sales',
                'Customer Relation',
                'Customer Support',
                'Package Summary',
                'Account Status',
                'Current Type (M/A)',
                'Business LV (Avg)',
                'Business LV (Last cycle)',
                'Registration Date',
                'Approve Date',
                'Current Start Date',
                'Current End Date',
                'Current Package',
                'Total Order',
                'Order Package',
                'Ontop Package',
                'Order Used',
                'Order Remaining',
                'Next Type (M/A)',
                'Next Type Start Date',
                'Next Type End Date'
            ]]
            const mapData = (e) => {
                return [
                    e.userCode || '-',
                    e.firstName || '-',
                    e.lastName || '-',
                    e.email || '-',
                    e.phoneNumber || '-',
                    e.saleCode || '-',
                    e.saleCodeSec || '-',
                    e.customerRetention || '-',
                    e.customerSupport || '-',
                    packageCode[e.packageCode] || '-',
                    ACCOUNT_STATUS[e.accountStatus] || '-',
                    SUBSCRIPTION_TYPE[e.currentSubscriptionType] || '-',
                    e.businessLevelAvg || '-',
                    e.businessLevelLast || '-',
                    e.registrationDate ? this.$dayjs(e.registrationDate).format('DD/MM/YYYY') : '-',
                    e.approveDate ? this.$dayjs(e.approveDate).format('DD/MM/YYYY') : '-',
                    e.currentStartDate ? this.$dayjs(e.currentStartDate).format('DD/MM/YYYY') : '-',
                    e.currentEndDate ? this.$dayjs(e.currentEndDate).format('DD/MM/YYYY') : '-',
                    packageCode[e.currentPackageCode] || '-',
                    e.totalOrder,
                    e.orderPackage,
                    e.ontopPackage,
                    e.orderUsed,
                    e.orderRemaining,
                    SUBSCRIPTION_TYPE[e.nextSubscriptionType] || '-',
                    e.nextStartDate ? this.$dayjs(e.nextStartDate).format('DD/MM/YYYY') : '-',
                    e.nextEndDate ? this.$dayjs(e.nextEndDate).format('DD/MM/YYYY') : '-'
                ]
            }
            let newCustomerList = []
            try {
                const res = await this.exportAIP(params)
                if (res.status === 'success') {
                    newCustomerList = res.data
                    if (newCustomerList) {
                        newCustomerList.forEach(e => {
                            const tempArr = mapData(e)
                            excelHeader.push(tempArr)
                        })
                        this.saveExcel(excelHeader, `export_customer_${this.$dayjs().format('DD/MM/YYYY')}`)
                    } else {
                        this.$swal({
                            title: 'ผิดพลาด !',
                            text: 'ไม่พบข้อมูลใน Database',
                            type: 'error'
                        })
                    }
                    this.onCloseDialog()
                    this.$emit('onExportSuccess')
                    this.$loading().close()
                }
            } catch (err) {
                this.$message.error(`Oops, Api is ${err} !`)
                this.onCloseDialog()
                this.$loading().close()
            }
        }
    }
}
</script>

<style lang="scss" scoped>
$blacl-color: #000000;
$gray-color: #606266;
.export {
    .btn-close {
        position: absolute;
        top: 0;
    }
    p {
        margin: 0 0 4px;
    }
    .title {
        display: flex;
        justify-content: center;
        font-weight: bold;
        font-weight: 600;
        font-size: 20px;
        line-height: 24px;
        color: $gray-color;
        margin-bottom: 30px;
    }
    .type-box {
        font-family: Sarabun;
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 18px;
        color: $gray-color;
    }
    .radio-box {
        display: flex;
        font-weight: normal;
        font-family: Sarabun;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        padding-bottom: 40px;
        color: $blacl-color;
    }
    .err-message {
        font-family: Sarabun;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        color: red;
    }
    .footer {
        display: flex;
        justify-content: center;
        .btn-export {
            font-weight: 500;
            font-size: 14px;
            line-height: 16px;
            margin-top: 20px;
            width: 147px;
            height: 40px;
        }
        .btn-cancel {
            font-weight: 500;
            font-size: 14px;
            line-height: 16px;
            margin-top: 20px;
            color: #333333;
            width: 147px;
            height: 40px;
        }
    }
    ::v-deep .el-dialog__body {
        padding: 0px 40px 20px !important;
    }
    ::v-deep .el-radio__inner {
        border-radius: 100%;
        width: 14px;
        height: 14px;
    }
    ::v-deep .el-radio__inner::after {
        width: 6px;
        height: 6px;
    }
    ::v-deep .el-dialog__headerbtn {
        top: 10px;
        font-size: 20px;
        .el-dialog__close {
            color: $blacl-color;
        }
    }
    ::v-deep .el-button {
        padding: 12px 35px !important;
    }
}
</style>
